import { Controller } from "@hotwired/stimulus"
import { createIcons, icons } from "lucide"

export default class extends Controller {
  static targets = ["message"]

  connect() {
    // Clear existing messages when connecting
    this.messageTargets.forEach(message => {
      setTimeout(() => {
        message.style.opacity = "0"
        message.addEventListener("transitionend", () => {
          message.remove()
        }, { once: true })
      }, 5000)
    })
  }

  // Called when a new message is added via Turbo Stream
  messageTargetConnected(element) {
    // Initialize Lucide icons in the new message
    createIcons({
      icons,
      attrs: {
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
      }
    })

    // Set up auto-removal
    setTimeout(() => {
      element.style.opacity = "0"
      element.addEventListener("transitionend", () => {
        element.remove()
      }, { once: true })
    }, 5000)
  }
}
